import { ReactNode } from 'react';

import { SliderProps } from '@mui/material';

import { SContainer, SSlider } from './styled';

type TMark = {
  label?: ReactNode;
  value: number;
};

type TBundleSliderProps = {
  disabled: boolean;
  disableFromIndex?: number;
  marks: TMark[];
  selectedBundlePlanPosition: number;
  shouldHide: boolean;
  onChange: (value: number) => void;
};

export const BundleSlider = ({
  disabled,
  disableFromIndex,
  marks,
  selectedBundlePlanPosition,
  shouldHide,
  onChange,
}: TBundleSliderProps) => {
  if (shouldHide || marks.length <= 1) {
    return null;
  }

  const size = marks.length;
  const min = marks[0].value;
  const max = marks[size - 1].value;

  const handleChange = (_: Event, value: number) => {
    const index = marks.findIndex((mark) => mark.value === value);

    if (typeof disableFromIndex === 'number' && index >= disableFromIndex) {
      onChange(value);
    }
  };

  return (
    <SContainer>
      <SSlider
        $disableFromIndex={disableFromIndex || 0}
        $size={size}
        disabled={disabled}
        marks={marks}
        max={max}
        min={min}
        step={null}
        value={selectedBundlePlanPosition}
        onChange={handleChange as SliderProps['onChange']}
      />
    </SContainer>
  );
};
